module.exports = __webpack_public_path__ + "media/src/images/icons/person-fdfbbed50251a9dc88a18aefad677414.svg";